"use client";

import React from "react";
import { Alert, AlertProps } from "@mui/material";

export type WcAlertProps = AlertProps;

export const WcAlert = (props: WcAlertProps) => <Alert {...props} />;

export default WcAlert;
